import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout';
import { Home, Work, Services, Studio, Contact, LocationPage, Insights, Article, ThankYou } from '@/pages';
import AnalyticsTracker from '@/components/AnalyticsTracker';
import { ChatbotProvider } from '@/components/ChatbotProvider';
import { AIChatbot } from '@/components/ui/AIChatbot';



/**
 * Main application component with routing configuration.
 *
 * @returns The root application component with all routes configured.
 */
const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <ChatbotProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<Work />} />
            <Route path="/services" element={<Services />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<Article />} />
            <Route path="/thank-you" element={<ThankYou />} />

            
            {/* SEO Pages */}
            <Route path="/locations/cyprus" element={<LocationPage location="cyprus" />} />
            <Route path="/locations/london" element={<LocationPage location="london" />} />
          </Routes>
        </Layout>
        <AIChatbot />
      </ChatbotProvider>
    </BrowserRouter>
  );
};

export default App;